import { useQuery, QueryResult } from "@apollo/client"
import {
  GET_TOURNAMENT_DETAIL,
  GET_TOURNAMENT_INFO,
  GET_TOURNAMENT_ORGANIZERS,
  GET_TOURNAMENT_PLAYERS,
  GET_TOURNAMENT_PLAYERS_SIMPLE,
} from "../queries/tournamentDetail"
import { Tournament } from ".."

interface TournamentInfoResponse {
  TournamentInfo: {
    Tournament: Tournament
    Related: Tournament[]
  }
}

interface TournamentInfoVars {
  TournamentInfoInput: {
    tournamentId: number
  }
}

/**
 * @deprecated quitar en la próxima versión.
 */
export const useTournamentDetail = (tournamentId: number) => {
  const { data, loading, error, refetch } = useQuery(GET_TOURNAMENT_DETAIL, {
    variables: { id: tournamentId },
    errorPolicy: "all",
    skip: !tournamentId,
  })

  return {
    tournament: data?.Tournament,
    loading,
    error,
    refetch,
  }
}

export const useTournamentInfo = (
  tournamentId: number,
): {
  tournament?: Tournament
  related?: Tournament[]
  loading: boolean
  error?: Error
  refetch: QueryResult<TournamentInfoResponse, TournamentInfoVars>["refetch"]
} => {
  const { data, loading, error, refetch } = useQuery<TournamentInfoResponse, TournamentInfoVars>(
    GET_TOURNAMENT_INFO,
    {
      variables: {
        TournamentInfoInput: { tournamentId },
      },
      errorPolicy: "all",
      skip: !tournamentId,
    },
  )

  return {
    tournament: data?.TournamentInfo?.Tournament,
    related: data?.TournamentInfo?.Related || [],
    loading,
    error: error as Error | undefined,
    refetch,
  }
}

export const useTournamentPlayers = (tournamentId: number, simple = false) => {
  const { data, loading, error, refetch } = useQuery(
    simple ? GET_TOURNAMENT_PLAYERS_SIMPLE : GET_TOURNAMENT_PLAYERS,
    {
      variables: {
        TournamentPlayerFilterFilter: { tournamentId },
      },
      errorPolicy: "all",
      skip: !tournamentId,
    },
  )

  const players = data?.allTournamentPlayers.map((x) => {
    const hasDocument = !!x.Person.documentNumber
    return {
      ...x,
      Person: {
        ...x.Person,
        hasDocument,
        documentNumber: hasDocument ? x.Person.documentNumber : "No informado",
        documentNumberType: hasDocument ? x.Person.documentNumberType : "",
      },
    }
  })

  return {
    players,
    loading,
    error,
    refetch,
  }
}

export const useTournamentOrganizers = (tournamentId: number, isAuthenticated: boolean) => {
  const { data, loading, error, refetch } = useQuery(GET_TOURNAMENT_ORGANIZERS, {
    variables: {
      TournamentOrganizerFilterFilter: { tournamentId },
    },
    errorPolicy: "all",
    skip: !tournamentId || !isAuthenticated,
  })

  return {
    organizers: data?.allTournamentOrganizers || [],
    loading,
    error,
    refetch,
  }
}
